import React from "react";

interface ButtonProps {
  text?: string;
  iconsrc?: string | null;
  className?: string;
  children?: React.ReactNode;
  handleOnClick?: () => void;
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const CustomButton = ({
  text,
  iconsrc,
  className = "",
  handleOnClick,
  children,
  size = "medium",
  disabled = false,
  type,
}: ButtonProps) => {
  const baseStyle =
    "flex items-center gap-2 rounded-full text-sm font-myYekanRegular subpixel-antialiased cursor-pointer";

  const sizeStyle = {
    small: "h-[32px] px-4 py-2",
    medium: "h-9 px-4 py-2",
    large: "h-[52px] px-12 py-4 rounded-xl",
  };

  const disabledStyle = disabled
    ? "opacity-50 cursor-not-allowed pointer-events-none"
    : "";

  const buttonClassName = `${baseStyle} ${sizeStyle[size]} ${disabledStyle} ${className}`;

  return (
    <button
      type={type}
      onClick={handleOnClick}
      className={buttonClassName}
      dir="rtl"
      disabled={disabled}
    >
      {children}
      {iconsrc && <img src={iconsrc} alt="logo" className="h-3.5 w-3.5" />}
      {text && <span>{text}</span>}
    </button>
  );
};

export default CustomButton;
